import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Helpers
import { getURLSegment } from '../../helpers/helpers.js';

// Components
import CalendarList from './CalendarList';
import CalendarSettings from './CalendarSettings';
import CalendarView from './CalendarView';
import CalendarSeats from './CalendarSeats.js';

const ScheduleManage = observer(class ScheduleManage extends React.Component {
  constructor() {
    super();

    this.state = {
      step: 1
    }
    // Bind this to functions
    this.setStep = this.setStep.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const { ScheduleStore, SessionStore } = this.props.store;
    const locationSid = getURLSegment(this, 3);

    this.setState({locationSid: locationSid});

    // Wait for schedule locations to be retrieved
    const locationDelay = setInterval(function(){
      if(!SessionStore.loading) {
        clearInterval(locationDelay);
        ScheduleStore.setScheduleLocation(locationSid);
      }
    }, 100);

    if(getURLSegment(this, 4) === 'calendar') {
      // Editing a calendar
      const calendarSid = getURLSegment(this, 5);

      this.setState({
        step: 2,
        calendarSid
      });
    } else if(getURLSegment(this, 4) === 'view') {
      // Editing a calendar
      const calendarSid = getURLSegment(this, 5);

      this.setState({
        step: 3,
        calendarSid
      });
    }
  }

  setStep(step) {
    this.setState({
      step
    });


    if(step === 1) {
      const baseUrl = `/${getURLSegment(this, 1)}/${getURLSegment(this, 2)}/${getURLSegment(this, 3)}`;

      this.props.routing.history.push(baseUrl);
    }
  }

  render() {
    const { translation } = this.props;
    const { ScheduleStore } = this.props.store;
    const { scheduleLocation } = ScheduleStore;

    if(scheduleLocation) {
      return(
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading.replace('%location%', scheduleLocation.title)}</h1>
            </div>
          </header>

          <div className="wrap">
            {this.state.step === 1 && this.state.locationSid &&
              <CalendarList
                {...this.props}
                locationSid={this.state.locationSid}
                setStep={this.setStep}
              />
            }

            {this.state.step === 2 &&
              <CalendarSettings
                {...this.props}
                locationSid={this.state.locationSid}
                calendarSid={getURLSegment(this, 5)}
                setStep={this.setStep}
              />
            }

            {this.state.step === 3 &&
              <CalendarView
                {...this.props}
                locationSid={this.state.locationSid}
                calendarSid={ getURLSegment(this, 5)}
                setStep={this.setStep}
              />
            }

            {this.state.step === 4 &&
              <CalendarSeats
                locationSid={this.state.locationSid}
                store={this.props.store}
                setStep={this.setStep}
              />
            }
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('ScheduleManage')(ScheduleManage);



// WEBPACK FOOTER //
// ./src/app/components/Schedule/ScheduleManage.js